import React, { FunctionComponent } from "react";
import { Alert } from "@cmsgov/ds-medicare-gov";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTypedTranslate } from "../helpers/intlHooks";

const EnrollmentDownAlert: FunctionComponent<{
  className?: string;
}> = ({ className }) => {
  const { feDisableHpmsEnrollment } = useFlags();
  const t = useTypedTranslate();

  return feDisableHpmsEnrollment ? (
    <Alert
      variation="error"
      className={className}
      heading={t("enrollment_down_alert.currently_down")}
    >
      {t("enrollment_down_alert.cannot_process")}
    </Alert>
  ) : null;
};

export default EnrollmentDownAlert;
